/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { fromLegacyPlacement } from '../placement-map';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { LEGACY_PLACEMENTS } from '../placement-map/legacy-placements';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { TLegacyPlacement, TPlacementOptions } from '../placement-map';
